import { useCallback, useState } from 'react';
import { useAppSelector } from '../../../redux/hook';
import { P2Accordion, P2Alert, P2TextDescription } from 'react-bootstrap-common-script';
import SignifyDocumentItem from '../component/signify-document-component';
import { Separator } from '../../../components/separator';
import StatusTag from '../../../components/status-tag/status-tag';
import { AccordionStatus } from '../../../models/enum/status-tag.enum';
import React from 'react';

interface SignifyFormAccordionProps {
  forms: [];
}
const SignifyFormAccordion = ({ forms }: SignifyFormAccordionProps) => {
  const loginUser = useAppSelector((state) => state.auth.AuthenticationSlice.loginUser);
  const singpassToken = useAppSelector((state) => state.auth.AuthenticationSlice.singpassToken);

  const [accordionSubtitle, setAccordionSubtitle] = useState<boolean>(true);

  // Toggle the accordion subtitle when called.
  const handleAccordionSubtitle = useCallback(() => {
    setAccordionSubtitle((prev) => !prev);
  }, [forms]);

  const hasPending = React.useMemo(() => {
    if (forms.length === 0) return false;

    return forms.some(
      (form: any) =>
        // Uncomment and adjust the below if you need to check owner conditions as well.
        form.owners.some((owner: { uinfin: string; endorsement_date?: string }) => owner.uinfin === loginUser?.uinfin && !owner.endorsement_date) &&
        form.signing_require &&
        form.signify_status.toLowerCase() !== 'signed'
    );
  }, [forms, loginUser?.uinfin]);

  const hasForms = forms && forms.length > 0;
  return (
    <div className='polymer-stage-e-accordion'>
      <P2Accordion
        defaultOpen={true}
        hasDivider={true}
        onToggle={handleAccordionSubtitle}
        title={
          <div className='polymer-accordion-listing_title'>
            <div style={{ marginBottom: '8px' }}>
              <StatusTag status={`${hasPending ? AccordionStatus.pending : AccordionStatus.completed}`} />
            </div>
            <div className='polymer-accordion-listing_title_wrap'>
              <h4>3. Forms for endorsement</h4>
            </div>
            {accordionSubtitle && hasForms && (
              <div className='polymer-stage-e-accordion-subtitle'>
                <P2TextDescription
                  color='#333'
                  description={
                    'Please review the implications carefully before signing.'
                  }
                />
              </div>
            )}
          </div>
        }>
        {/* Accordion's Content Starts Here --- */}
        {hasForms ? (
          <div className='d-flex flex-column' style={{ marginTop: '16px' }}>
            {forms.map((item: any, index: number) => {
              const isFirst = index === 0;
              return (
                <div key={index}>
                  {isFirst ? null : <Separator style={{ margin: '16px 0' }} />}
                  <SignifyDocumentItem
                    form={item}
                    form_name={item.title}
                    form_link={item.signing_link}
                    form_endorsement_date={item.signify_status === 'signed' ? item.lastSignedDate : ''}
                    form_signify_status={item.signify_status}
                    isSigningRequire={item.signing_require}
                    formData={item?.form_data ?? undefined}
                    singpassToken={singpassToken}
                  />
                </div>
              );
            })}
          </div>
        ) : (
          <div className='polymer-stage-e-document-items'>
            <P2Alert variant={'info'} withBorder={true} text={'No forms for endorsement.'} />
          </div>
        )}
      </P2Accordion>
    </div>
  );
};

export default SignifyFormAccordion;
